// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import Stone from './Stone';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(Stone);
